import ApiResourceManager from '../ApiResourceManager';

/**
 * A partner's own root domain, under which shop-backend serves the four manager apps on
 * fixed labels. The partner endpoints act on the signed-in partner admin's own provider
 * and are gated on the provider's `partner_custom_dashboard_domain` flag (403 outside the
 * pilot); `getForProvider` is the read-only staff mirror support uses from the Partners
 * page, which answers whatever the flag says.
 */
export default class PartnerDashboardDomainManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/partner-settings/dashboard-domain',
    });

  connect = (rootHost) =>
    this.request({
      method: 'PUT',
      url: '/partner-settings/dashboard-domain',
      data: { root_host: rootHost },
    });

  // Re-attaches and re-checks every app under the root. Throttled server-side.
  verify = () =>
    this.request({
      method: 'POST',
      url: '/partner-settings/dashboard-domain/verify',
    });

  detach = () =>
    this.request({
      method: 'DELETE',
      url: '/partner-settings/dashboard-domain',
    });

  getForProvider = (serviceProviderId) =>
    this.request({
      method: 'GET',
      url: '/service-provider-dashboard-domain',
      headers: { 'x-on-behalf-of-service-provider': serviceProviderId },
    });
}
